import { Link } from '@chakra-ui/react';
import { Link as RRLink } from 'react-router-dom';

import { DASHBOARD } from '../../../constants/urls';

type DashboardBackButtonProps = {
  to?: string;
};

const DashboardBackButton = ({ to = DASHBOARD }: DashboardBackButtonProps) => (
  <Link as={RRLink} to={to} mt={1} ml={{ base: 0, md: 8, lg: 16 }}>
    {'< BACK TO DASHBOARD'}
  </Link>
);

export default DashboardBackButton;
